module.exports = __webpack_public_path__ + "static/media/jumping.e4457b63.jpg";